import {Injectable} from '@angular/core';
import {CacheItem} from '../objects/cache-item';

@Injectable({
  providedIn: 'root'
})
export class CacheService {
  private cache: Map<string, CacheItem>;

  constructor() {
    this.cache = new Map();
  }

  public get(key: string, defaultObject?: unknown): CacheItem {
    if (!this.cache.has(key)) {
      const cacheItem = new CacheItem();
      cacheItem.key = key;
      cacheItem.item = defaultObject;
      this.cache.set(key, cacheItem);
    }

    return this.cache.get(key);
  }

  public delete(key: string) {
    if (this.cache.has(key)) {
      this.cache.delete(key);
    }
  }

  public has(key: string): boolean {
    return this.cache.has(key);
  }

  public clear() {
    this.cache.clear();
  }
}
